import { useSearchStore } from '../../stores/search-store.js';
import { useSearch } from '../../hooks/useSearch.js';

const METRICS = [
  { label: 'Name',         order: 'name' },
  { label: 'Mana Value',   order: 'cmc' },
  { label: 'USD Price',    order: 'usd' },
  { label: 'EDHREC Rank',  order: 'edhrec' },
  { label: 'Rarity',       order: 'rarity' },
];

const selectClass =
  'bg-gray-800 border border-gray-700 rounded-lg px-2.5 py-1.5 text-xs text-gray-300 focus:outline-none focus:border-orange-500 transition-colors cursor-pointer';

const toggleBtn = (active: boolean) =>
  `px-2.5 py-1.5 text-xs font-medium transition-colors ${
    active
      ? 'bg-orange-600 text-white'
      : 'bg-gray-800 text-gray-500 hover:text-gray-300'
  }`;

export function SortControl() {
  const sortOrder = useSearchStore((s) => s.sortOrder);
  const sortDir = useSearchStore((s) => s.sortDir);
  const setSortOrder = useSearchStore((s) => s.setSortOrder);
  const results = useSearchStore((s) => s.results);
  const { execute } = useSearch();

  const reSearch = () => { if (results) void execute(1); };

  const handleMetric = (order: string) => {
    setSortOrder(order, sortDir);
    reSearch();
  };

  const handleDir = (dir: 'asc' | 'desc') => {
    setSortOrder(sortOrder, dir);
    reSearch();
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-600">Sort</span>
      <select
        value={sortOrder}
        onChange={(e) => handleMetric(e.target.value)}
        className={selectClass}
      >
        {METRICS.map((m) => (
          <option key={m.order} value={m.order}>{m.label}</option>
        ))}
      </select>
      <div className="flex rounded-lg border border-gray-700 overflow-hidden">
        <button
          onClick={() => handleDir('asc')}
          className={toggleBtn(sortDir === 'asc') + ' rounded-l-lg border-r border-gray-700'}
        >
          ↑ Asc
        </button>
        <button
          onClick={() => handleDir('desc')}
          className={toggleBtn(sortDir === 'desc') + ' rounded-r-lg'}
        >
          ↓ Desc
        </button>
      </div>
    </div>
  );
}
